import React, { useContext, useMemo } from 'react';
import { SingleDatePicker } from '@ally/forms';
import { Label } from '@ally/metronome-ui';
import { withProps } from '@ally/validator';
import { DELIVERY_DATE_ADVANCE_DAYS, oneTime } from '../../constants';
import { TransferSpeedsContext, useComputedValues, useHolidays, } from '../../hooks';
import { getDatePickerProps, getMinDeliveryDate, isLoadingRemote, } from '../../utils';
import validator from './validator';
var DeliveryDateInput = function () {
    var _a = useContext(TransferSpeedsContext), transferSpeeds = _a.transferSpeeds, withdrawalDate = _a.withdrawalDate;
    var _b = useComputedValues(), transferType = _b.transferType, frequency = _b.frequency, disableForm = _b.disableForm;
    var holidays = useHolidays();
    var label = frequency === oneTime ? 'Deliver on' : 'Deliver first transfer on';
    var minDeliveryDate = useMemo(function () {
        return getMinDeliveryDate({
            frequency: frequency,
            transferSpeeds: transferSpeeds,
            transferType: transferType,
        });
    }, [frequency, transferSpeeds, transferType]);
    var validate = useMemo(function () {
        return withProps(validator, {
            frequency: frequency,
            holidays: holidays,
            minDeliveryDate: minDeliveryDate,
            maxAdvanceDuration: [DELIVERY_DATE_ADVANCE_DAYS, 'days'],
            transferType: transferType,
        });
    }, [frequency, holidays, minDeliveryDate, transferType]);
    var _c = useMemo(function () {
        return getDatePickerProps({
            holidays: holidays,
            minDate: minDeliveryDate,
            transferType: transferType,
            maxAdvanceDuration: [DELIVERY_DATE_ADVANCE_DAYS, 'days'],
            frequency: frequency,
        });
    }, [holidays, minDeliveryDate, transferType, frequency]), isDayBlocked = _c.isDayBlocked, isOutsideRange = _c.isOutsideRange;
    var shouldDisable = isLoadingRemote([transferSpeeds, withdrawalDate]);
    return (React.createElement(React.Fragment, null,
        React.createElement(Label, { htmlFor: "deliveryDate", display: "inline-block" }, label),
        React.createElement(SingleDatePicker, { name: "deliveryDate", ariaLabel: label, validate: validate, disabled: shouldDisable || disableForm, isDayBlocked: isDayBlocked, isOutsideRange: isOutsideRange })));
};
export default DeliveryDateInput;
//# sourceMappingURL=Input.js.map